import { FormattedDate } from 'react-intl';
import { LocalDate } from '@js-joda/core';

import { IWithContextProps, withContext } from '@tock/coretypes';
import React from 'react';

interface Props {
  displayYearAs?: 'numeric' | '2-digit';
  displayMonthAs?: 'numeric' | '2-digit' | 'long' | 'short' | 'narrow';
  monthValue: LocalDate;
  showYear?: boolean;
}

interface DefaultProps {
  displayYearAs?: 'numeric' | '2-digit';
  displayMonthAs?: 'numeric' | '2-digit' | 'long' | 'short' | 'narrow';
  showYear?: boolean;
}

/**
 * Displays a month in the business locale.
 */
class DisplayMonthInner extends React.Component<Props & IWithContextProps> {
  static defaultProps: DefaultProps = {
    displayMonthAs: 'long',
    displayYearAs: 'numeric',
    showYear: true,
  };

  toDateObject = (localDate: LocalDate): Date => {
    return new Date(Date.UTC(localDate.year(), localDate.monthValue() - 1, localDate.dayOfMonth()));
  };

  render() {
    const {
      context: { locale },
      displayMonthAs,
      displayYearAs,
      monthValue,
      showYear: showYearFromProps,
    } = this.props;

    const showYear = showYearFromProps ? { year: displayYearAs } : {};
    const showMonth = { month: displayMonthAs };

    // I don't think this should actually work but it mirrors what the
    // code used to do and will pass typechecks, so:
    const funkyLocaleOverrideProps = {
      locales: [locale],
    };

    return (
      <FormattedDate
        {...showMonth}
        {...showYear}
        {...funkyLocaleOverrideProps}
        timeZone="UTC"
        value={this.toDateObject(monthValue)}
      />
    );
  }
}

export const DisplayMonth = withContext(DisplayMonthInner);
